import React from "react";
import "../../../public/css/style.less";
import {
  apiBatchRequest,
  apiBatchRequestWithoutLoader,
  apiRequestNoLoadder,
  CancelRequest,
  RenewCancelToken,
} from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import ReportButtons from "../../../utils/ReportButtons";
import PageFilter from "../../common/PageFilter";
import { controlType } from "../../../constants/common";
import PageHeader from "../../common/PageHeader";
import { Tooltip } from "@material-ui/core";
import camelcaseKeys from "camelcase-keys";
import SearchBar from "../../common/AutoSearch/SearchBar";
import EditIOSSalesComp from "./EditIOSSalesComp";
import { ShowToast, toastType } from "../../../utils/toast-service";
import commonLabels from "../../../constants/messageConstants";
import {
  IsSectionVisible,
  UpdateColumnWithConfiguration,
} from "../../../utils/helper";
import { Operators, SECTIONS } from "../../../constants/appConstants";
import { PaginatedGridTable } from "../../common/Table/PaginatedTable";
import { withRouter } from "react-router-dom";
import { routes } from "../../../constants/routes";

class IOSSalesComps extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedMarketId: this.props.globalMarketId,
      salesCompsSummaryData: [],
      configuration: [],
      userConfiguration: [],
      selectedEditRowId: undefined,
      detailView: false,
      ViewTitle: undefined,
      actionType: undefined,
      getSubMarketMaster: [],
      openFilter: false,
      getMarketMaster: [],
      companyMasterDetails: [],
      brokerSellerDetails: [],
      propertyNameAddrCostar: [],
      rowsPerPage: 20,
      reloadTable: false,
      enableFilterButton: false,
      selectedValue: null,
      selectedValueId: -1,
      searchInput: "",
      filterSelectedData: [],
      isInAddMode: false,
      pageNumber: 0,
      companyId: "",
      closeDate: "",
      bldgId: "",
      submarketId: "",
      sellerId: "",
    };
  }

  componentDidMount() {
    RenewCancelToken();
    this.getRequiredData(this.state.selectedMarketId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.globalMarketId !== this.state.selectedMarketId) {
      this.getRequiredData(nextProps.globalMarketId);
      this.setState({
        selectedMarketId: nextProps.globalMarketId,
        selectedValue: null,
        selectedValueId: -1,
      });
    }
  }

  componentWillUnmount() {
    CancelRequest();
  }

  getRequiredDataWithoutLoader = (selectedMarketId) => {
    this._asyncRequest = apiBatchRequestWithoutLoader([
      {
        url: API_URL.Master.getMarketSubmarket,
        key: "getMarketSubmarket",
        params: { businessLineId: 2, marketId: selectedMarketId },
      },
    ])
      .then((response) => {
        this._asyncRequest = null;
        if (response.getMarketSubmarket.submarket.success === true) {
          this.setState({
            getMarketMaster:
              camelcaseKeys(response.getMarketSubmarket.market.data) || [],
            getSubMarketMaster:
              camelcaseKeys(response.getMarketSubmarket.submarket.data) || [],
            selectedValueId: !this.props.globalMarketId?.includes?.("|")
              ? this.props.globalMarketId
              : -1,
            enableFilterButton: true,
          });
        } else {
          ShowToast(
            response.getMarketSubmarket.submarket.message,
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  getRequiredData = (selectedMarketId) => {
    if (!selectedMarketId) return;

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.IOSSalesComps.iosSalesCompsSummaryData,
        key: "salesCompsSummaryData",
        params: {
          marketId: selectedMarketId,
          buyerId: this.state.companyId,
          bldgId: this.state.bldgId,
          submarketId: this.state.submarketId,
          sellerId: this.state.sellerId,
          pageNumber: this.state.pageNumber + 1,
          pageSize: this.state.rowsPerPage,
        },
      },
      {
        url: API_URL.Master.GetUserConfigurations,
        key: "userConfiguration",
        params: { sectionId: SECTIONS.IOS_Sale_Comp_Listing },
        fromCache: true,
        duration: 60,
      },
      {
        url: API_URL.Master.getBuildingNameAddressCostarMaster,
        key: "propertyNameAddrCostar",
        params: {
          businessLineId: 2,
          searchText: null,
          marketId: selectedMarketId,
        },
      },
    ])
      .then((response) => {
        this._asyncRequest = null;
        if (response.salesCompsSummaryData.success === true) {
          this.getRequiredDataWithoutLoader(selectedMarketId);
          const userConfig =
            response.userConfiguration.data ||
            JSON.parse(window.sessionStorage.getItem("userConfigurations"));
          this.setState({
            salesCompsSummaryData:
              camelcaseKeys(response.salesCompsSummaryData.data) || [],
            configuration:
              camelcaseKeys(response.salesCompsSummaryData.configuration) || [],
            userConfiguration: camelcaseKeys(userConfig) || [],
            rowsPerPage:
              response.userConfiguration.data?.[2]?.rowPerPage || 20,
            propertyNameAddrCostar:
              camelcaseKeys(response.propertyNameAddrCostar.data) || [],
            reloadTable: !this.state.reloadTable,
          });
        } else {
          ShowToast(
            response.salesCompsSummaryData.message,
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  reloadGridData = (selectedMarketId) => {
    if (!selectedMarketId) return;
    debugger;
    console.log(this.state.companyId);
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.IOSSalesComps.iosSalesCompsSummaryData,
        key: "salesCompsSummaryData",
        params: {
          marketId: selectedMarketId,
          buyerId: this.state.companyId,
          bldgId: this.state.bldgId,
          submarketId: this.state.submarketId,
          sellerId: this.state.sellerId,
          pageNumber: this.state.pageNumber + 1,
          pageSize: this.state.rowsPerPage,
        },
      },
    ])
      .then((response) => {
        this._asyncRequest = null;
        if (response.salesCompsSummaryData.success === true) {
          const rows = camelcaseKeys(response.salesCompsSummaryData.data) || [];
          this.setState({
            salesCompsSummaryData: rows,
            reloadTable: !this.state.reloadTable,
          });
        } else {
          ShowToast(
            response.salesCompsSummaryData.message,
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  reloadData = () => {
    this.reloadGridData(this.state.selectedMarketId);
    this.setState({
      detailView: false,
      selectedEditRowId: undefined,
      companyMasterDetails: [],
      reloadTable: !this.state.reloadTable,
    });
  };

  onFilterChange = (selectedData) => {
    if (selectedData.length > 0) {
      let bldgId = "";
      let submarketId = "";
      let sellerId = "";
      let closeDate = "";

      for (let i = 0; i < selectedData.length; i++) {
        const selected = selectedData[i].selected ?? [];
        if (selectedData[i].key === "buildingName") {
          bldgId = selected.map((item) => item.buildingId).join("|");
        }
        if (selectedData[i].key === "subMarket") {
          submarketId = selected.map((item) => item.subMarketId).join("|");
        }
        if (selectedData[i].key === "seller") {
          sellerId = selected.map((item) => item.sellerId).join("|");
        }
        if (selectedData[i].key === "closedate") {
          closeDate = selected.map((item) => item.closedate).join("|");
        }
      }

      this.setState(
        {
          filterSelectedData: [selectedData],
          bldgId,
          submarketId,
          sellerId,
          closeDate,
          pageNumber: 0,
          reloadTable: !this.state.reloadTable,
        },
        () => this.reloadGridData(this.state.selectedMarketId)
      );
    } else {
      this.resetFilters();
    }
  };

  resetFilters = () => {
    this.setState(
      {
        filterSelectedData: null,
        companyId: "",
        bldgId: "",
        submarketId: "",
        sellerId: "",
        closeDate: "",
        pageNumber: 0,
        reloadTable: !this.state.reloadTable,
      },
      () => this.reloadGridData(this.state.selectedMarketId)
    );
  };

  onSearchInputChange = (filter, value) => {
    apiRequestNoLoadder({
      url: API_URL.Master.companyMasterDetails,
      params: { businessLineId: 2, searchText: value },
    })
      .then(({ data }) => {
        this.setState({
          companyMasterDetails: camelcaseKeys(data.data || data) || [],
        });
      })
      .catch(() => {
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          "Server error"
        );
      });
  };

  handleSearchChange = (e, value) => {
    debugger;
    const companyId = value?.companyId || "";
    const companyName = value?.companyName || "";
    this.setState(
      {
        searchInput: companyName,
        companyId,
        pageNumber: 0,
        reloadTable: !this.state.reloadTable,
      },
      () => this.reloadGridData(this.state.selectedMarketId)
    );
  };

  onInputChange = (filter, value) => {
    if (filter?.key !== "seller") return;

    apiRequestNoLoadder({
      url: API_URL.Master.getALLSellerFirm,
      params: { businessLineId: 2, searchText: value },
    })
      .then(({ data }) => {
        this.setState({
          brokerSellerDetails: camelcaseKeys(data.data || data) || [],
        });
      })
      .catch(() => {
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          "Server error"
        );
      });
  };

  renderActionColumn = (cellInfo) => (
    <Tooltip title="View">
      <a
        className="default-text"
        aria-label="viewComp"
        size="small"
        onClick={() => {
          this.setState({ isInAddMode: false });
          this.onRowClick(cellInfo);
        }}
      >
        <span className="default-text span-link">
          {cellInfo.buyer || "---"}
        </span>
      </a>
    </Tooltip>
  );

  onAddNewClick = () => {
    this.setState({
      isInAddMode: true,
      detailView: true,
      selectedEditRowId: undefined,
      ViewTitle: "Add",
      actionType: "Add",
    });
  };

  onRowClick = (data) => {
    this.setState({
      detailView: true,
      selectedEditRowId: data.compId,
      ViewTitle: "Edit",
      actionType: "Edit",
    });
    this.props.history.push(`/${routes.iossalescomps}/${data.compId}`);
  };

  onBackClick = () => {
    this.setState({ detailView: false, selectedEditRowId: undefined });
    this.props.history.push(`/${routes.iossalescomps}`);
  };

  reloadPage = (page, rowcount) => {
    this.setState(
      {
        pageNumber: page,
        rowsPerPage: rowcount,
        reloadTable: !this.state.reloadTable,
      },
      () => this.reloadGridData(this.state.selectedMarketId)
    );
  };

  handleCheck = (key) =>
    (this.state.userConfiguration?.length > 0
      ? this.state.userConfiguration
      : this.state.configuration || []
    ).some(
      (item) =>
        ((item.key || item.dbColumn || "").toLowerCase() === key.toLowerCase()) &&
        item.isVisible === true
    );

  enableFilter = () => {
    const openFilter = this.state.openFilter;
    this.setState({ openFilter: !openFilter });
  };

  render() {
    const {
      salesCompsSummaryData,
      userConfiguration,
      getMarketMaster,
      getSubMarketMaster,
      brokerSellerDetails,
      propertyNameAddrCostar,
      searchInput,
      detailView,
      selectedEditRowId,
      configuration,
      openFilter,
    } = this.state;

    const userConfigSource = 
      userConfiguration?.length > 0
        ? userConfiguration
        : (configuration || []).map((item) => ({
          ...item,
          key: item.key || item.dbColumn,
        }));  

    const userConfig = (userConfigSource || []).map((item) => {
      const column = { ...item };

      if ((column.key || "").toLowerCase() === "buyer") {
        column.renderComponent = "renderActionColumn";
      }

      return column;
    }).sort((a, b) =>
      a.attributeSortOrder > b.attributeSortOrder ? 1 : -1
    );
    const assignedMarkets = this.props.userConfig?.userMarket || [];
    const { compId = -1 } = this.props.match?.params || -1;

    if (compId && compId != -1 && !detailView) {
      this.setState({
        selectedEditRowId: compId,
        ViewTitle: "Edit",
        actionType: "Edit",
        detailView: true,
        isInAddMode: false,
      });
    }

    if (compId && detailView) {
      return (
        <EditIOSSalesComp
          globalMarketId={this.props.globalMarketId}
          selectedCompId={selectedEditRowId}
          onBackClick={this.onBackClick}
          ViewTitle={this.state.ViewTitle}
          actionType={this.state.actionType}
          isInAddMode={this.state.isInAddMode}
          reloadData={this.reloadData}
          companyMasterDetails={this.state.companyMasterDetails}
          getBuildingMaster={this.state.propertyNameAddrCostar}
          onMarketChange={this.props.onMarketChange}
          assignedMarkets={assignedMarkets}
          getSubMarketMaster={getSubMarketMaster}
          getMarketMaster={getMarketMaster}
        />
      );
    }

    if (detailView) {
      return (
        <EditIOSSalesComp
          globalMarketId={this.props.globalMarketId}
          selectedCompId={selectedEditRowId}
          onBackClick={this.onBackClick}
          ViewTitle={this.state.ViewTitle}
          actionType={this.state.actionType}
          isInAddMode={this.state.isInAddMode}
          reloadData={this.reloadData}
          companyMasterDetails={this.state.companyMasterDetails}
          getBuildingMaster={this.state.propertyNameAddrCostar}
          onMarketChange={this.props.onMarketChange}
          assignedMarkets={assignedMarkets}
          getSubMarketMaster={getSubMarketMaster}
          getMarketMaster={getMarketMaster}
        />
      );
    }

    return (
      <>
        <div className="row no-print">
          <div className="col-md-3 col-lg-3">
            <PageHeader title="IOS Sales Comps" />
          </div>
          <div className="col-md-9 col-lg-9">
            <div className="row">
              <div className="col-md-6 col-lg-6">
                <SearchBar
                  size="large"
                  name="searchInput"
                  value={searchInput || ""}
                  label="Search"
                  placeholder="Search buyer"
                  searchInput={searchInput}
                  companyMasterDetails={this.state.companyMasterDetails}
                  isOwner={true}
                  handleChange={this.handleSearchChange}
                  onInputChange={this.onSearchInputChange}
                  reloadData={this.resetFilters}
                />
              </div>
              <div className="col-md-3 col-lg-3"></div>
              <div className="col-md-3 col-lg-3">
                <ReportButtons
                  resetPage={[]}
                  openFilter={this.state.openFilter}
                  enableFilter={this.enableFilter}
                  handleSubmit={[]}
                  data={salesCompsSummaryData}
                  fileName={"IOSSalesComps.xlsx"}
                  enableFilterButton={this.state.enableFilterButton}
                  ParentSection={SECTIONS.IOS_Sale_Comps}
                />
              </div>
            </div>
          </div>
        </div>

        {salesCompsSummaryData && userConfig.length > 0 && (
          <div className="row" style={{ marginTop: "0px" }}>
            <div className="col-sm-12 col-lg-12">
              <PageFilter
                onInputChange={this.onInputChange}
                resetFilters={this.resetFilters}
                autoFilter={true}
                openAppliedFilterPane={true}
                filterSelectedData={this.state.filterSelectedData}
                filterApplied={true}
                filterAlwaysVisible={openFilter}
                openFilter={true}
                onFilterChanged={this.onFilterChange}
                filterConfig={[
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: propertyNameAddrCostar,
                    key: "buildingName",
                    placeholder: "",
                    title: "Property Name",
                    isVisible: this.handleCheck("buildingName"),
                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: [
                      ...new Map(
                        getSubMarketMaster.map((item) => [item.subMarket, item])
                      ).values(),
                    ],
                    key: "subMarket",
                    placeholder: "",
                    title: "Sub Market",
                    isVisible: this.handleCheck("subMarket"),
                  },
                  {
                    multiple: false,
                    type: controlType.Autofill,
                    source: brokerSellerDetails,
                    key: "seller",
                    placeholder: "",
                    title: "Seller Company",
                    isVisible: this.handleCheck("seller"),
                  },
                  {
                    multiple: true,
                    type: controlType.DateRangePicker,
                    key: "closedate",
                    placeholder: "",
                    title: "Close Date",
                    isVisible: this.handleCheck("closedate"),
                    operator: [
                      Operators.GreaterThanEqualsTo,
                      Operators.LessThanEqualsTo,
                    ],
                  },
                ]}
                defaultSelectedData={[]}
                selectedData={[]}
                gridColumn={4}
              />
            </div>
          </div>
        )}

        {salesCompsSummaryData && userConfig.length > 0 && (
          <div className="row" style={{ marginTop: "0px" }}>
            <div className="col-sm-12 col-lg-12">
              <PaginatedGridTable
                validationMessage={[]}
                rowCount={this.state.rowsPerPage > 0 ? this.state.rowsPerPage : 20}
                columns={UpdateColumnWithConfiguration(
                  userConfig,
                  configuration,
                  []
                )}
                selectedEditRowId={selectedEditRowId}
                data={salesCompsSummaryData}
                renderActionColumn={this.renderActionColumn}
                reload={this.state.reloadTable}
                config={userConfig}
                AddNewRecord={{
                  action: this.onAddNewClick,
                  title: "Add IOS Sales Comp",
                  visible: IsSectionVisible(
                    SECTIONS.IOS_Sale_Comps,
                    SECTIONS.IOS_Sale_Comp_Listing,
                    SECTIONS.ADD_EDIT
                  ),
                }}
                reloadPaginatedData={this.reloadPage}
                pageNumber={this.state.pageNumber}
              />
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(IOSSalesComps);

